import { render, staticRenderFns } from "./ProductWeight5.vue?vue&type=template&id=1c0a7504&scoped=true"
import script from "./ProductWeight5.vue?vue&type=script&lang=js"
export * from "./ProductWeight5.vue?vue&type=script&lang=js"
import style0 from "./ProductWeight5.vue?vue&type=style&index=0&id=1c0a7504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a7504",
  null
  
)

export default component.exports